// extracted by mini-css-extract-plugin
module.exports = {"form":"profile-change-info_form__3auto","block":"profile-change-info_block__1O9Uc","item":"profile-change-info_item__2SRMW"};